/* unplugin-vue-components disabled */import { render } from "./CountDown.vue?vue&type=template&id=5808ea6d&scoped=true"
import script from "./CountDown.vue?vue&type=script&lang=js"
export * from "./CountDown.vue?vue&type=script&lang=js"

import "./CountDown.vue?vue&type=style&index=0&id=5808ea6d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5808ea6d"]])

export default __exports__